import React from 'react';
import { motion } from 'framer-motion';

const Logo = () => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', userSelect: 'none' }}>
            <svg
                width="60"
                height="60"
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ filter: 'drop-shadow(0 0 12px rgba(212, 255, 158, 0.4))' }}
            >
                {/* Abstract Leaf Shape */}
                <motion.path
                    d="M50 95C50 95 20 80 10 50C0 20 30 0 50 0C70 0 100 20 90 50C80 80 50 95 50 95Z"
                    stroke="var(--accent)"
                    strokeWidth="4"
                    initial={{ pathLength: 0 }}
                    animate={{ pathLength: 1 }}
                    transition={{ duration: 1.5, ease: "easeInOut" }}
                />

                {/* Digital Circuit Lines / Veins */}
                <motion.path
                    d="M50 95V20"
                    stroke="var(--accent)"
                    strokeWidth="3"
                    strokeLinecap="round"
                    initial={{ pathLength: 0 }}
                    animate={{ pathLength: 1 }}
                    transition={{ duration: 1, delay: 0.5 }}
                />
                <motion.path
                    d="M50 70L25 55"
                    stroke="var(--accent)"
                    strokeWidth="3"
                    strokeLinecap="round"
                    initial={{ pathLength: 0 }}
                    animate={{ pathLength: 1 }}
                    transition={{ duration: 0.8, delay: 0.8 }}
                />
                <motion.path
                    d="M50 50L75 35"
                    stroke="var(--accent)"
                    strokeWidth="3"
                    strokeLinecap="round"
                    initial={{ pathLength: 0 }}
                    animate={{ pathLength: 1 }}
                    transition={{ duration: 0.8, delay: 1.0 }}
                />
                <motion.circle
                    cx="25" cy="55" r="4"
                    fill="var(--accent)"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.5, delay: 1.2 }}
                />
                <motion.circle
                    cx="75" cy="35" r="4"
                    fill="var(--accent)"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.5, delay: 1.4 }}
                />
            </svg>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{
                    fontSize: '1.8rem',
                    fontWeight: '700',
                    color: 'var(--text-main)',
                    letterSpacing: '-0.03em',
                    lineHeight: 0.9,
                    fontFamily: 'Manrope, sans-serif'
                }}>
                    Seikaia
                </span>
                <span style={{
                    fontSize: '0.75rem',
                    color: 'var(--accent)',
                    letterSpacing: '0.25em',
                    textTransform: 'uppercase',
                    opacity: 0.9,
                    marginTop: '4px'
                }}>
                    Bio-Systems
                </span>
            </div>
        </div>
    );
};

export default Logo;
